





















































import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";
import classes from "@/config/wow/classes";

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import usersAPI from "@/api/users";

/**
 * Transfer character modal.
 */
@Component
export default class TransferCharacterDialog extends Vue {
	$refs!: {
		modal: Dialog;
	};

	/// Injections
	imageLinks = imageLinks;
	classes = classes;

	/// Properties
	@Prop()
	onAfterTransfer!: () => Promise<void>;

	/// Attributes
	isLoading = false;
	characterToTransfer: any | null = null;
	characters: any[] | null = null;

	/// Methods
	async open(character: any) {
		this.characterToTransfer = character;
		this.characters = null;
		this.isLoading = true;
		this.$refs.modal.open();
		await this.refreshCharacters();
		this.isLoading = false;
	}

	close() {
		this.$refs.modal.close();
	}

	async refreshCharacters() {
		const characters = await usersAPI.getCharactersToTransferTo(this.characterToTransfer.id);
		if (characters) {
			this.characters = characters;
		}
	}

	async handleClaimCharacterClick(character: any) {
		this.isLoading = true;
		try {
			await usersAPI.transferCharacter(this.characterToTransfer.id, character.name, character.realm.name);
			await this.refreshCharacters();
			if (this.onAfterTransfer) {
				await this.onAfterTransfer();
			}
		}
		catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
